import { render, staticRenderFns } from "./android_sdk.vue?vue&type=template&id=9e64388a&scoped=true"
import script from "./android_sdk.vue?vue&type=script&lang=js"
export * from "./android_sdk.vue?vue&type=script&lang=js"
import style0 from "./android_sdk.vue?vue&type=style&index=0&id=9e64388a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e64388a",
  null
  
)

export default component.exports